// TestimonialsSection.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './../style/TestimonialsSection.module.scss';

import SwiperArrowLeft from '../icons/SwiperArrowLeft';
import SwiperArrowRight from '../icons/SwiperArrowRight';

class TestimonialsSection extends React.Component {
  constructor(props) {
    super(props);
    this.swiperRef = React.createRef();
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
    this.state = {
      isVisible: false
    };
  }

  componentDidMount() {
    const { mainpage } = this.props;
    this.timer = setTimeout(() => {
      this.setState({ isVisible: true });
    }, mainpage ? 4000 : 100);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev();
    }
  }

  render() {
    const { page_data, feedback, feedback_legal, user_profile_type } = this.props;
    const { isVisible } = this.state;

    if (!isVisible) {
      return (
        <section className={styles.testimonialsSection} style={{ minHeight: '0' }}>
        </section>
      );
    }

    if (user_profile_type == `legal`) {
      return (
        <section className={styles.testimonialsSection}>
          <Container className={styles.container}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>Что говорят о нас клиенты</h2>
              <a href={page_data?.link_feedback} className={styles.viewAll}>Все отзывы →</a>
            </div>
            
            <div style={{ width: `100%`, height: `800px`, overflow: `hidden`, position: `relative`}}>
              <iframe title="Отзывы" style={{ display: `block`, width: '100%', maxWidth: `560px`, marginLeft: `auto`, marginRight: `auto`, height: '100%', border: '1px solid #e6e6e6', borderRadius: '8px', boxSizing: 'border-box' }} src="https://yandex.ru/maps-reviews-widget/114543751405?comments"></iframe>
            </div>
            {/*
            <div className={styles.sliderContainer}>
              <Swiper
                ref={this.swiperRef}
                modules={[Navigation, Pagination]}
                spaceBetween={10}
                slidesPerView={1}
                loop={true}
                autoHeight={true}
                pagination={{
                  type: 'progressbar',
                  el: `.${styles.swiperPagination}`,
                }}
                breakpoints={{
                  576: {
                    slidesPerView: 1,
                    spaceBetween: 10
                  },
                  992: {
                    slidesPerView: 2,
                    spaceBetween: 10
                  }
                }}
              >
                {feedback_legal.map((testimonial) => (
                  <SwiperSlide key={testimonial?.id}>
                    <div className={styles.testimonialCard_legal}>
                      <div className={styles.testimonialHeader}>
                        <div className={styles.userPhoto}>
                          <img src={testimonial?.photo} alt={testimonial?.name} width="50" height="50" />
                        </div>
                        <div className={styles.userInfo}>
                          <div className={styles.userInfo_name}>
                            <div className={styles.userName}>{testimonial?.name}</div>
                            <div className={styles.rating}>
                              {[...Array(5)].map((_, i) => (
                                <svg 
                                  key={i} 
                                  width="16" 
                                  height="15" 
                                  viewBox="0 0 16 15" 
                                  fill={i < testimonial?.rating ? "#FFD900" : "#ECECEC"} 
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M7.52447 0.463526C7.67415 0.0028708 8.32585 0.00286996 8.47553 0.463525L9.90837 4.87336C9.97531 5.07937 10.1673 5.21885 10.3839 5.21885H15.0207C15.505 5.21885 15.7064 5.83865 15.3146 6.12336L11.5633 8.84878C11.3881 8.9761 11.3148 9.20179 11.3817 9.4078L12.8145 13.8176C12.9642 14.2783 12.437 14.6613 12.0451 14.3766L8.29389 11.6512C8.11865 11.5239 7.88135 11.5239 7.70611 11.6512L3.95488 14.3766C3.56303 14.6613 3.03578 14.2783 3.18546 13.8176L4.6183 9.4078C4.68524 9.20179 4.61191 8.9761 4.43667 8.84878L0.685441 6.12336C0.293584 5.83866 0.494972 5.21885 0.979333 5.21885H5.6161C5.83272 5.21885 6.02469 5.07937 6.09163 4.87336L7.52447 0.463526Z"/>
                                </svg>
                              ))}
                            </div>
                          </div>
                          <div className={styles.userInfo_dolznost}>{testimonial?.dolznost}</div>
                        </div>
                      </div>
                      <div className={styles.testimonialText}>
                        {testimonial?.text}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className={styles.swiperControls}>
                <div className={styles.swiperPagination}></div>
                <button 
                  className={`${styles.swiperButton} ${styles.swiperButtonPrev} d-none`}
                  onClick={this.prevSlide}
                >
                  <SwiperArrowLeft />
                </button>
                <button 
                  className={`${styles.swiperButton} ${styles.swiperButtonNext} ${styles.swiperButtonLegal}`}
                  onClick={this.nextSlide}
                >
                  <SwiperArrowRight />
                </button>
              </div>
            </div>
            */}
          </Container>
        </section>
      );
    }

    return (
      <section className={styles.testimonialsSection}>
        <Container className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Что говорят о нас клиенты</h2>
            <a href={page_data?.link_feedback} className={styles.viewAll}>Все отзывы →</a>
          </div>
          
          <div style={{ width: `100%`, height: `800px`, overflow: `hidden`, position: `relative`}}>
            <iframe title="Отзывы" style={{ display: `block`, width: '100%', maxWidth: `560px`, marginLeft: `auto`, marginRight: `auto`, height: '100%', border: '1px solid #e6e6e6', borderRadius: '8px', boxSizing: 'border-box' }} src="https://yandex.ru/maps-reviews-widget/114543751405?comments"></iframe>
          </div>
          {/*
          <div className={styles.sliderContainer}>
            <Swiper
              ref={this.swiperRef}
              modules={[Navigation, Pagination]}
              spaceBetween={10}
              slidesPerView={1}
              loop={true}
              pagination={{
                type: 'progressbar',
                el: `.${styles.swiperPagination}`,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 2,
                  spaceBetween: 10
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 10
                }
              }}
              style={{ height: `145px` }}
            >
              {feedback.map((testimonial) => (
                <SwiperSlide key={testimonial.id}>
                  <div className={styles.testimonialCard}>
                    <div className={styles.testimonialHeader}>
                      <div className={styles.userPhoto}>
                        <img src={testimonial.photo} alt={testimonial.name} width="50" height="50" />
                      </div>
                      <div className={styles.userInfo}>
                        <div className={styles.userName}>{testimonial.name}</div>
                        <div className={styles.rating}>
                          {[...Array(5)].map((_, i) => (
                            <svg 
                              key={i} 
                              width="16" 
                              height="15" 
                              viewBox="0 0 16 15" 
                              fill={i < testimonial.rating ? "#FFD900" : "#ECECEC"} 
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M7.52447 0.463526C7.67415 0.0028708 8.32585 0.00286996 8.47553 0.463525L9.90837 4.87336C9.97531 5.07937 10.1673 5.21885 10.3839 5.21885H15.0207C15.505 5.21885 15.7064 5.83865 15.3146 6.12336L11.5633 8.84878C11.3881 8.9761 11.3148 9.20179 11.3817 9.4078L12.8145 13.8176C12.9642 14.2783 12.437 14.6613 12.0451 14.3766L8.29389 11.6512C8.11865 11.5239 7.88135 11.5239 7.70611 11.6512L3.95488 14.3766C3.56303 14.6613 3.03578 14.2783 3.18546 13.8176L4.6183 9.4078C4.68524 9.20179 4.61191 8.9761 4.43667 8.84878L0.685441 6.12336C0.293584 5.83866 0.494972 5.21885 0.979333 5.21885H5.6161C5.83272 5.21885 6.02469 5.07937 6.09163 4.87336L7.52447 0.463526Z"/>
                            </svg>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className={styles.testimonialText}>
                      {testimonial.text}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className={styles.swiperControls}>
              <div className={styles.swiperPagination}></div>
              <button 
                className={`${styles.swiperButton} ${styles.swiperButtonPrev} d-none`}
                onClick={this.prevSlide}
              >
                <SwiperArrowLeft />
              </button>
              <button 
                className={`${styles.swiperButton} ${styles.swiperButtonNext}`}
                onClick={this.nextSlide}
              >
                <SwiperArrowRight />
              </button>
            </div>
          </div>
          */}
        </Container>
      </section>
    );
  }
}

TestimonialsSection.propTypes = {
  page_data: PropTypes.object,
  feedback: PropTypes.array,
  feedback_legal: PropTypes.array,
  user_profile_type: PropTypes.string,
  mainpage: PropTypes.bool
};

TestimonialsSection.defaultProps = {
  page_data: {},
  feedback: [],
  feedback_legal: [],
  user_profile_type: '',
  mainpage: false
};

export default TestimonialsSection;